import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import CardSale from "../CardSale";
import Pagination from "../Pagination";
import ButtonPrimary from "../ButtonPrimary";
import {
  Container,
  ContainerPage,
  ContainerProductFound,
  ContainerProductList,
  ContainerProducts,
  LoaderContainer,
  NoResultsFound
} from "./styles";
import Loader from "react-loader-spinner";

export default function ItemList({ products, loading, loadMore, haveFilter, searchTerm = '', isMobile, totalizadorGeral, columns = 4, onClearFilters }) {
  const store = useSelector(state => state.storeByUser.data);
  const { limit } = useSelector(
    state => state.search
  );

  useEffect(() => {
    if (window.screen.height <= 600) {
      const text = document.createElement('h1')

      document.body.appendChild(text)
    }
  }, [])

  return (
    <>
      <Container>
        <ContainerProducts>
          <ContainerProductList id="featured-products" columns={columns}>
            {loading && (
              // <LoaderContainer>
              //   <Loader type="Oval" color="#00786A" height={36} width={36} />
              // </LoaderContainer>
              <div></div>
            )}
            {!loading && (
              <>
                {(products && products.length === 0) && (
                  <NoResultsFound>
                    <div className="icon">
                      <FiSearch />
                    </div>
                    <h3>Ah, não!</h3>
                    <p>Não encontramos nenhum produto. Tente ajustar os filtros ou a busca.</p>
                    {onClearFilters && (
                      <ButtonPrimary
                        className="clear-filters-btn"
                        text="Limpar filtros"
                        onClick={onClearFilters}
                      />
                    )}
                  </NoResultsFound>
                )}
                {products &&
                  products.map((product) => (
                    <CardSale key={product.id} product={product} hasSelectedStore={store !== null} />
                  ))}
              </>
            )}
          </ContainerProductList>
          <ContainerPage>
            {totalizadorGeral > 0 && (
              <>
                {loading === false && isMobile && (
                  <ContainerProductFound>
                    <span>{totalizadorGeral} produtos encontrados</span>
                  </ContainerProductFound>
                )}
                <Pagination show={loading === false} totalItens={totalizadorGeral} itensByPage={limit} loadMore={loadMore}/>
              </>
            )}
          </ContainerPage>
        </ContainerProducts>
      </Container>
    </>
  );
}
